module.exports = __webpack_public_path__ + "static/media/onboarding_logo.d8e05e48.png";